export class WbA11y {
  constructor() {
    this.bindListeners();
  }

  init() {
    return new Promise((resolve) => {
      this.addSrOnlyText();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-skip-to-content__link--content', _this.scrollToContent.bind(_this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-skip-to-content__link--footer', _this.scrollToFooter.bind(_this));
    this.disableKeyboardWhileLoading();
  }

  scrollToFooter() {
    document.querySelector('#mastfoot').focus();
  }

  scrollToContent() {
    document.querySelector('#page__main').focus();
  }

  addSrOnlyText() {
    document.querySelectorAll('a[target="_blank"], a[download]')?.forEach((link) => {
      const hasSrOnlyText = link.querySelector('.sr-only');
      const lang = document.documentElement.getAttribute('lang');

      if (hasSrOnlyText) return;

      if (lang === 'fr') link.insertAdjacentHTML('beforeend', '<span class="sr-only">(ouvre un nouvel onglet)</span>');
      else link.insertAdjacentHTML('beforeend', '<span class="sr-only">(opens in a new tab)</span>');
    });
  }

  disableKeyboardWhileLoading() {
    document.onkeydown = function (e) {
      const overlayIsActive = document.querySelector('#page').classList.contains('wb-load-overlay');
      if (overlayIsActive) return false;
    };
  }
}
